module.exports = __webpack_public_path__ + "static/media/DSC04545.46ac7056.jpg";